import request from '@/utils/analyticsRequest'

export const KB_FILE_ACCEPT = '.pdf,.doc,.docx,.txt,.csv'

export function formatStorageBytes(bytes) {
  const value = Number(bytes || 0)
  if (value >= 1073741824) return `${(value / 1073741824).toFixed(2)} GB`
  if (value >= 1048576) return `${(value / 1048576).toFixed(2)} MB`
  if (value >= 1024) return `${(value / 1024).toFixed(1)} KB`
  return `${value} B`
}

export function fileIconType(fileCategory) {
  switch (fileCategory) {
    case 'pdf': return 'pdf'
    case 'word': return 'word'
    case 'text': return 'text'
    case 'link': return 'link'
    default: return 'file'
  }
}

export function listKnowledgeBases() {
  return request({ url: '/api/v1/ghl/ai/knowledge-bases', method: 'get' })
}

export function getKnowledgeBaseStorage() {
  return request({ url: '/api/v1/ghl/ai/knowledge-bases/storage', method: 'get' })
}

export function createKnowledgeBase(data) {
  return request({
    url: '/api/v1/ghl/ai/knowledge-bases',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' }
  })
}

export function updateKnowledgeBase(id, data) {
  return request({
    url: `/api/v1/ghl/ai/knowledge-bases/${id}`,
    method: 'put',
    data,
    headers: { 'Content-Type': 'application/json' }
  })
}

export function deleteKnowledgeBase(id) {
  return request({ url: `/api/v1/ghl/ai/knowledge-bases/${id}`, method: 'delete' })
}

export function listKnowledgeBaseItems(kbId, parentId = 0) {
  return request({
    url: `/api/v1/ghl/ai/knowledge-bases/${kbId}/items`,
    method: 'get',
    params: { parentId: parentId || undefined }
  })
}

export function createKnowledgeBaseFolder(kbId, parentId, name) {
  return request({
    url: `/api/v1/ghl/ai/knowledge-bases/${kbId}/folders`,
    method: 'post',
    data: { parentId: parentId || null, name },
    headers: { 'Content-Type': 'application/json' }
  })
}

export function addKnowledgeBaseLink(kbId, parentId, name, url) {
  return request({
    url: `/api/v1/ghl/ai/knowledge-bases/${kbId}/links`,
    method: 'post',
    data: { parentId: parentId || null, name, url },
    headers: { 'Content-Type': 'application/json' }
  })
}

export function renameKnowledgeBaseItem(kbId, itemId, name) {
  return request({
    url: `/api/v1/ghl/ai/knowledge-bases/${kbId}/items/${itemId}`,
    method: 'put',
    data: { name },
    headers: { 'Content-Type': 'application/json' }
  })
}

export function deleteKnowledgeBaseItem(kbId, itemId) {
  return request({
    url: `/api/v1/ghl/ai/knowledge-bases/${kbId}/items/${itemId}`,
    method: 'delete'
  })
}

export function uploadKnowledgeBaseFile(kbId, parentId, file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: `/api/v1/ghl/ai/knowledge-bases/${kbId}/upload`,
    method: 'post',
    params: { parentId: parentId || undefined },
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
